import Adicionar from './Adicionar';
import Processar from './Processar';

export const AvaliacoesAdicionar = Adicionar;
export const AvaliacoesProcessar = Processar;
